import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImportIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.8652 12.7617V13.7826C17.8652 15.212 17.8652 15.9267 17.587 16.4726C17.3423 16.9529 16.9519 17.3433 16.4716 17.588C15.9257 17.8662 15.211 17.8662 13.7816 17.8662H6.63534C5.20595 17.8662 4.49126 17.8662 3.9453 17.588C3.46507 17.3433 3.07463 16.9529 2.82994 16.4726C2.55176 15.9267 2.55176 15.212 2.55176 13.7826V12.7617",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.95543 7.80649L10.2092 3.55276M10.2092 3.55276L14.4629 7.80649M10.2092 3.55276L10.2092 13.7617",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgImportIcon;
